import { Injectable } from '@angular/core';
import { Subject} from "rxjs";
import {FlashMessage} from "@shared/partials/flash-message/flash-message.models";
import {flashMessageData} from "@shared/partials/flash-message/flash-message.data";


@Injectable({providedIn: 'root'})
export class FlashMessageService {
  constructor() { this.showMessage$ = new Subject<FlashMessage>() }

  public showMessage$: Subject<FlashMessage>

  public show(messageKey:string){
    if(flashMessageData[messageKey]===undefined){
      console.error(`FlashMessage for key ${messageKey} doesn't exist in flashMessageData`)
    }
    else this.showMessage$.next(flashMessageData[messageKey])
  }
  public showCustom(flashMessage:FlashMessage){ this.showMessage$.next(flashMessage) }
  public hide(){ this.showMessage$.next(null) }
}
